import { render, staticRenderFns } from "./dmReportForms.vue?vue&type=template&id=20635eb7&scoped=true&"
import script from "./dmReportForms.vue?vue&type=script&lang=ts&"
export * from "./dmReportForms.vue?vue&type=script&lang=ts&"
import style0 from "./dmReportForms.vue?vue&type=style&index=0&id=20635eb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20635eb7",
  null
  
)

export default component.exports